(function($) {
	formHelper.addRule({
		form: '#form-reset-password',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			}
		}
	});
})(jQuery);
